import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mailsubscription',
  templateUrl: './mailsubscription.component.html',
  styleUrls: ['./mailsubscription.component.css']
})
export class MailsubscriptionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
